/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { loadMomentTimezone } from "app/client/lib/imports";

/**
 * Returns the browser timezone, using moment.tz.guess(), allowing overriding it via a "timezone"
 * URL parameter, for the sake of tests.
 */
export async function guessTimezone() {
  const moment = await loadMomentTimezone();
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("timezone") || moment.tz.guess();
}
